import { connect } from 'react-redux';

import MappingManualView from '../../../components/mapping/manual/View';
import {
  getMappingUpdatingCode,
  isMappingFetching,
  isMappingUpdating,
} from '../../../reducers/analyticsApp';

const mapStateToProps = (state) => ({
  update: getMappingUpdatingCode(state) !== null,
  updating: isMappingUpdating(state),
  fetching: isMappingFetching(state),
});

export default connect(mapStateToProps)(MappingManualView);
